module.exports = __webpack_public_path__ + "media/icons/no_check_red@2x-f9db27f7.png";